import moment from "moment";
import { IOrder } from "../types/IOrder";
import { END_TIME_EXTENSION_HOURS, START_TIME_HOUR } from "./constants";
import { IOrderSource } from "../types/IOrderSource";
import { createRoot } from "react-dom/client";
import { IItemBrief } from "../types/IItemBrief";
import { IItem } from "../types/IItem";
import OrderReceipt from "../components/OrderReceipt/OrderReceipt";
import ExpiryReceipt from "../components/ExpiryReceipt/ExpiryReceipt";
import QRCode from "react-qr-code";
import { IExpiryConfig } from "../types/IExpiryConfig";

export const getItemBriefLabel = (item: IItemBrief) =>
  `${item.name} (${item.size})`;
export const getItemLabel = (item: IItem) => `${item.name} (${item.size})`;

export const getNextArrRotationValue = (array: any[], currentValue: any) => {
  let index = array.findIndex((v) => v === currentValue);
  index = index === array.length - 1 ? 0 : index + 1;
  return array[index];
};

export const printNewReceipt = (
  order: IOrder,
  orderSource: IOrderSource | null,
  inhouseReceiptOnly: boolean = false,
) => {
  const printWindow = window.open("", "", "width=320,height=600")!;
  if (!printWindow) return;
  printWindow.document.write('<pre id="printArea" style="margin:0;"></pre>');
  printWindow.document.close();

  const domNode = printWindow.document.getElementById("printArea");
  const root = createRoot(domNode!);
  root.render(
    <OrderReceipt
      order={order}
      orderSource={orderSource!}
      inhouseReceiptOnly={inhouseReceiptOnly}
    />,
  );

  setTimeout(() => {
    printWindow.print();
  }, 700);
};

export const printExpiryReceipt = (expiryConfig: IExpiryConfig) => {
  const printWindow = window.open("", "", "width=320,height=600")!;
  if (!printWindow) return;
  printWindow.document.write('<pre id="printArea" style="margin:0;"></pre>');
  printWindow.document.close();

  const domNode = printWindow.document.getElementById("printArea");
  const root = createRoot(domNode!);
  root.render(<ExpiryReceipt expiryConfig={expiryConfig} />);

  setTimeout(() => {
    printWindow.print();
  }, 300);
};

export const printReceipt = (
  order: IOrder,
  orderSource: IOrderSource | null,
) => {
  let orderLabel =
    orderSource && order.source_identifier
      ? `${orderSource.name}-${order.source_identifier}`.toUpperCase()
      : order.order_number;
  const takeawayLabel = order.is_takeaway_order ? "TAKEAWAY " : "DINEIN ";

  const printWindow = window.open("", "", "width=320,height=600")!;
  printWindow.document.write("<html><head><title>Receipt</title>");
  printWindow.document.write("</head><body>");
  printWindow.document.write('<pre id="printArea">');
  printWindow.document.write(
    `<span style='font-size:30px; display:flex; justify-content:center;'><strong>${orderLabel}</strong></span>`,
  );
  printWindow.document.writeln("---------------------------------------");
  printWindow.document.write(
    `<div style='display:flex; justify-content:center; text-align:center;'>SPLASH THE SODA HUB</div>`,
  );
  printWindow.document.writeln("---------------------------------------");

  printWindow.document.write(`Order ID: ${order.id.split("-")[4]}\n`);
  printWindow.document.write(`Date: ${formatDate(order.created_at)}\n`);
  printWindow.document.write("---------------------------------------\n");

  order.order_items.forEach((orderItem) => {
    printWindow.document.write(
      `<div style='display:flex; justify-content:space-between;'><div>${
        orderItem.quantity
      } x ${
        orderItem.item.size.charAt(0).toUpperCase() +
        orderItem.item.size.slice(1)
      } ${orderItem.item.name}</div><div>PKR ${
        orderItem.total_price
      }</div></div>`,
    );
  });

  printWindow.document.write("---------------------------------------\n");
  printWindow.document.write(
    `<div style='display:flex; justify-content:space-between;'><div></div><div>TOTAL PKR ${order.total}</div></div>`,
  );
  printWindow.document.write("---------------------------------------\n");
  printWindow.document.write("Thank you for your visit!\n");
  printWindow.document.write("Please enjoy & come again soon.\n");
  printWindow.document.write("---------------------------------------\n");

  const qrElementId = `order-${order.id}-qr-root`;

  if (order.gst_invoice_id) {
    printWindow.document.write(
      `PRA E-Invoicenumber:\n${order.gst_invoice_id}\n\n`,
    );
    printWindow.document.write(`<div id="${qrElementId}"></div>`);
    const domNode = printWindow.document.getElementById(qrElementId);
    const root = createRoot(domNode!);
    root.render(<QRCode value={order.gst_invoice_id} size={100} />);
  }
  printWindow.document.write("</pre>");

  printWindow.document.write("</body></html>");

  const anotherReceiptOrderItems = order.order_items.filter(
    (orderItem) => orderItem.item.requires_extra_receipt,
  );

  if (anotherReceiptOrderItems.length > 0) {
    printWindow.document.write(
      "<div style=' page-break-before: always; '></div>",
    );

    printWindow.document.write('<pre id="printArea">');
    printWindow.document.write(
      `<div style='font-size:15px; text-align:center; margin:0; padding:0;'><strong>${orderLabel} - ${takeawayLabel}</strong></div>`,
    );
    printWindow.document.write("---------------------------------------\n");
    printWindow.document.write(`Order ID: ${order.id.split("-")[4]}\n`);
    printWindow.document.write(`Date: ${formatDate(order.created_at)}\n`);
    printWindow.document.write("---------------------------------------\n");

    anotherReceiptOrderItems.forEach((anotherReceiptOrderItem) => {
      printWindow.document.write(
        `${anotherReceiptOrderItem.quantity} x ${
          anotherReceiptOrderItem.item.size.charAt(0).toUpperCase() +
          anotherReceiptOrderItem.item.size.slice(1)
        } ${anotherReceiptOrderItem.item.name}\n`,
      );
    });

    printWindow.document.write("</pre>");
  }

  setTimeout(() => {
    printWindow.print();
  }, 700);
};

export const formatDate = (dateStr: string) =>
  moment(dateStr).format("DD-MMMM-YYYY / hh:mm A");

export const getTodayTimings = () => {
  const todayStart = moment().startOf("day");
  const todayEnd = moment().endOf("day");
  if (
    moment().toDate().getTime() <
    todayStart.clone().add(END_TIME_EXTENSION_HOURS, "hour").toDate().getTime()
  ) {
    todayStart.subtract(1, "day");
    todayEnd.subtract(1, "day");
  }

  return {
    startTime: todayStart.clone().add(START_TIME_HOUR, "hour"),
    endTime: todayEnd.clone().add(END_TIME_EXTENSION_HOURS, "hour"),
  };
};

export const getShortId = (uuid: string) => uuid.split("-")[4];
